<div
  [style.color]="splitterForm.get('splitters').value ? 'black' : '#cccccc'"
  (click)="
    splitterForm.get('splitters').setValue(!splitterForm.get('splitters').value)
  "
>
  <mat-icon class="option">horizontal_split</mat-icon>
</div>
